// js/custom-element/section/product-list/product-list.js
if (!customElements.get('product-list')) {
  var ProductList = class extends CustomHTMLElement {
    constructor() {
      super()
      this.infinite = this.dataset.infiniteScroll === 'true'
      this.productListInner = this.querySelector('.product-list__inner')
      this.productItems = Array.from(this.querySelectorAll('product-item, product-ad'))
      if(this.infinite) {
        this.page = 1
        this.innerContentSelector  = '.product-list__inner'
        this.initInfiniteScroll()
      }
    }
    connectedCallback() {
      if(!this.infinite) {
        this.addEventListener('prev-next:prev', this.previous.bind(this))
        this.addEventListener('prev-next:next', this.next.bind(this))
        if (!this.hidden && this.staggerApparition) {
          this._staggerProductsApparition()
        }
      }
    }
    observeLastListChild() {
      const wrap = this.querySelector(this.innerContentSelector);
      this.target = wrap.lastElementChild;
      this.observer.observe(this.target);
    }
  
    initInfiniteScroll() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.page++;
            this.fetchNextPage(this.page);
          }
        });  
      });
      this.observeLastListChild();
      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener('infinite-loader:updated', () => {
        if (!this.dataset.loaderDisconnected) {
          this.observer.unobserve(this.target);
          this.observeLastListChild();
        }
      });
  
      this.addEventListener('infinite-loader:disconnect', () => {
        this.observer.unobserve(this.target);
        this.setAttribute('data-loader-disconnected', true);
      });
    }

    fetchNextPage(e) {
      if (e <= this.dataset.pageSize) {
        const t = `${window.location.origin}/${this.dataset.next}`
        const i = new URL(t)
        i.searchParams.set("page", e)
        const r = i.href
        fetch(`${r}`, { method: "GET", headers: { "Content-Type": "text/html" } })
          .then((e) => e.text())
          .then((e) => {
            const t = new DOMParser().parseFromString(e, "text/html")
            const i = t.querySelector(this.innerContentSelector).innerHTML
            this.productListInner.insertAdjacentHTML("beforeend", i)
            this.dispatchEvent(new CustomEvent('infinite-loader:updated'));
          })
          .catch((e) => {
            console.error("Error:", e)
          })
      }
    }
    get staggerApparition() {
      return this.hasAttribute('stagger-apparition')
    }
    get apparitionAnimation() {
      return (this._animation =
        this._animation ||
        new CustomAnimation(
          new ParallelEffect(
            this.productItems.map((item, index) => {
              return new CustomKeyframeEffect(
                item,
                {
                  opacity: [0, 1],
                  transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, 'translateY(0)'],
                },
                {
                  duration: 600,
                  delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index - Math.min(3 * index * index, 100 * index),
                  easing: 'ease',
                }
              )
            })
          )
        ))
    }
    // Move to previous products (if any)
    previous(event) {
      const directionFlip = window.themeVariables.settings.direction === 'ltr' ? 1 : -1,
        columnGap = parseInt(getComputedStyle(this).getPropertyValue('--product-list-column-gap'))
      event.target.nextElementSibling.removeAttribute('disabled')
      event.target.toggleAttribute('disabled', this.productListInner.scrollLeft * directionFlip - (this.productListInner.clientWidth + columnGap) <= 0)
      this.productListInner.scrollBy({ left: -(this.productListInner.clientWidth + columnGap) * directionFlip, behavior: 'smooth' })
    }
    // Move to next products (if any)
    next(event) {
      const directionFlip = window.themeVariables.settings.direction === 'ltr' ? 1 : -1,
        columnGap = parseInt(getComputedStyle(this).getPropertyValue('--product-list-column-gap'))
      event.target.previousElementSibling.removeAttribute('disabled')
      event.target.toggleAttribute('disabled', this.productListInner.scrollLeft * directionFlip + (this.productListInner.clientWidth + columnGap) * 2 >= this.productListInner.scrollWidth)
      this.productListInner.scrollBy({ left: (this.productListInner.clientWidth + columnGap) * directionFlip, behavior: 'smooth' })
    }
    attributeChangedCallback(name) {
      if (!this.staggerApparition) {
        return
      }
      switch (name) {
        case 'hidden':
          if (!this.hidden) {
            this.productListInner.scrollLeft = 0
            this.productListInner.parentElement.scrollLeft = 0
            this.querySelector('.prev-next-button--prev')?.setAttribute('disabled', '')
            this.querySelector('.prev-next-button--next')?.removeAttribute('disabled')
            this._staggerProductsApparition()
          } else {
            this.apparitionAnimation.finish()
          }
      }
    }
    async _staggerProductsApparition() {
      this.productItems.forEach((item) => (item.style.opacity = 0))
      await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 })
      this.apparitionAnimation.play()
    }
  }
  __publicField(ProductList, 'observedAttributes', ['hidden'])
  window.customElements.define('product-list', ProductList)
}
